/* eslint-disable react/prop-types */
// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// formik components
import { ErrorMessage, Field } from "formik";

// components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { useLocation, useParams } from "react-router-dom";

function FormField({
  label,
  name,
  success,
  error,
  placeholder,
  disabled,
  horizontal = false,
  wrapperProps,
  ...rest
}) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const isDisabled = disabled ?? (id && !containEdit);
  return (
    <SoftBox mb={horizontal ? 0 : 1.5} {...wrapperProps}>
      {label && (
        <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {label}
          </SoftTypography>
        </SoftBox>
      )}

      <Field
        success={!containEdit && !isDisabled && success}
        error={!isDisabled && error}
        disabled={isDisabled}
        placeholder={!isDisabled ? placeholder : "Trống"}
        name={name}
        as={SoftInput}
        {...rest}
      />
      <SoftBox mt={horizontal ? 0 : 0.75}>
        <SoftTypography component="div" variant="caption" color="error">
          <ErrorMessage name={name} />
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  success: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  horizontal: PropTypes.bool,
};

export default FormField;
